// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 960) return "static/chunks/960-d65f9c56b7bcfe6c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"56":"00b8fe0a815631af","907":"bd622208057f996a"}[chunkId] + ".js";
};